import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { PageTitle, Spinner } from "../../components/Shell";

export default function Audit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/tenant/audit").then((r) => setLogs(r.data.logs)).catch(() => {});
  }, []);

  if (!logs) return <Spinner />;

  return (
    <div data-testid="tenant-audit">
      <PageTitle title="Jejak Audit" sub="Setiap tindakan direkodkan — siapa, apa dan bila" />
      <div className="bg-card rounded-xl border border-brand-deep/10 overflow-x-auto">
        <table className="w-full text-sm min-w-[680px]">
          <thead>
            <tr className="border-b border-brand-deep/10 text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3">Masa</th>
              <th className="px-5 py-3">Tindakan</th>
              <th className="px-5 py-3">Entiti</th>
              <th className="px-5 py-3">Butiran</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.log_id} className="border-b border-brand-deep/5" data-testid={`audit-row-${l.log_id.slice(-6)}`}>
                <td className="px-5 py-3 text-xs font-mono whitespace-nowrap">{fmtDate(l.timestamp)}</td>
                <td className="px-5 py-3"><span className="text-xs font-bold text-brand-deep bg-brand-light rounded-full px-2.5 py-1">{l.action}</span></td>
                <td className="px-5 py-3 text-xs font-mono">{l.entity}</td>
                <td className="px-5 py-3 text-xs text-muted-foreground">{l.detail || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <p className="px-5 py-8 text-center text-sm text-muted-foreground">Tiada log audit.</p>}
      </div>
    </div>
  );
}
